/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiBridgeAlert,
    ApiBridgeAlertFromJSON,
    ApiBridgeAlertToJSON,
    ApiBridgeAlerts,
    ApiBridgeAlertsFromJSON,
    ApiBridgeAlertsToJSON,
    BridgeAlertsPage,
    BridgeAlertsPageFromJSON,
    BridgeAlertsPageToJSON,
} from '../models';

export interface FindAllBridgeAlertsRequest {
    page: number;
    size: number;
    personId?: string;
}

export interface FindBridgeAlertsByTransactionIdRequest {
    transactionId: string;
}

export interface GetBridgeAlertRequest {
    id: number;
}

/**
 * 
 */
export class BridgeAlertApi extends runtime.BaseAPI {

    /**
     * Fetch all bridge alerts
     */
    async findAllBridgeAlertsRaw(requestParameters: FindAllBridgeAlertsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeAlertsPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllBridgeAlerts.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllBridgeAlerts.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.personId !== undefined) {
            queryParameters['personId'] = requestParameters.personId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/bridge-alerts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeAlertsPageFromJSON(jsonValue));
    }

    /**
     * Fetch all bridge alerts
     */
    async findAllBridgeAlerts(requestParameters: FindAllBridgeAlertsRequest, initOverrides?: RequestInit): Promise<BridgeAlertsPage> {
        const response = await this.findAllBridgeAlertsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches bridge alerts transaction by id
     */
    async findBridgeAlertsByTransactionIdRaw(requestParameters: FindBridgeAlertsByTransactionIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiBridgeAlerts>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling findBridgeAlertsByTransactionId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/transactions/{transactionId}/bridge-alerts`.replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiBridgeAlertsFromJSON(jsonValue));
    }

    /**
     * Fetches bridge alerts transaction by id
     */
    async findBridgeAlertsByTransactionId(requestParameters: FindBridgeAlertsByTransactionIdRequest, initOverrides?: RequestInit): Promise<ApiBridgeAlerts> {
        const response = await this.findBridgeAlertsByTransactionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get bridge alert
     */
    async getBridgeAlertRaw(requestParameters: GetBridgeAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiBridgeAlert>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBridgeAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/bridge-alerts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiBridgeAlertFromJSON(jsonValue));
    }

    /**
     * Get bridge alert
     */
    async getBridgeAlert(requestParameters: GetBridgeAlertRequest, initOverrides?: RequestInit): Promise<ApiBridgeAlert> {
        const response = await this.getBridgeAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
